// extracted by mini-css-extract-plugin
export var boxItems = "_7c-1";
export var boxItemsLg = "_7c-2";
export var button = "_7c-7";
export var buttonHoverless = "_7c-9";
export var buttonLg = "_7c-8";
export var filterGroupBox = "_7c-0";
export var icon = "_7c-3";
export var iconSecondary = "_7c-6";
export var iconWrapper = "_7c-4";
export var iconWrapperLg = "_7c-5";
export var truncatedLabel = "_7c-a";